// extracted by mini-css-extract-plugin
export default {"input":"NumberInputWithDecimals_input__IFYGt","unit":"NumberInputWithDecimals_unit__pNuZ8"};